import "babel-polyfill"; // 解决Ie9
import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";
import "./element";
import "./theme/index.css";
import * as filters from "./filtres/index"; // 全局过滤器
import "./role"; // 权限
// import "./mock"; // 模拟数据
import "./assets/icons/iconfont";
import "./assets/icons/iconfont.css";
import IconSvg from "./components/common/IconSvg.vue"; // svg组件
import editor from "./components/editor/index.vue";
// import VueClipboard from "vue-clipboard2";
// import Router from 'vue-router'
import "./assets/css/main.css";

// 引入i18n
import i18n from "./lang/index";

// 引入jsonp
import { VueJsonp } from "vue-jsonp";
Vue.use(VueJsonp);
// Vue.use(VueClipboard);
// 注册全局组件（register global）
Vue.component("icon-svg", IconSvg);
Vue.component("editor", editor);

// 注册全局实用程序过滤器（register global utility filters）.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;
Vue.config.debug = true; //开启错误提示
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app");

window.$ = window.jQuery = require("jquery");

// Vue.use(Router)
// 原型中新增catch捕获error
// const routerPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//     return routerPush.call(this, location).catch(error => error)
// }
